/**
 * 🎓 Onboarding Hints — first-turn UX for non-gamer / impatient players.
 *
 * Shows bouncing arrows above leader heads and contextual tooltips on
 * action buttons during turns 1-2 only, then auto-dismisses.
 *
 * Alliance map (loosely based on real-world geopolitics — also matches
 * how the AI hostility logic in turn_routes.py treats relations):
 *   - STRONG_ALLY: handshake + golden glow, points to Diplomacy
 *   - SEMI_ALLY:   handshake (dimmer), points to Diplomacy
 *   - ENEMY:       radiation symbol + red pulse, points to attack actions
 */

export const ALLIANCE_MAP = {
  USA: { strongAlly: 'EU',  semiAlly: null, enemies: ['RUS', 'CHN', 'NK'] },
  EU:  { strongAlly: 'USA', semiAlly: null, enemies: ['RUS', 'CHN', 'NK'] },
  RUS: { strongAlly: 'CHN', semiAlly: 'NK', enemies: ['USA', 'EU']        },
  CHN: { strongAlly: 'RUS', semiAlly: 'NK', enemies: ['USA', 'EU']        },
  NK:  { strongAlly: 'CHN', semiAlly: 'RUS', enemies: ['USA', 'EU']       },
};

/**
 * Get the relationship between two factions for onboarding purposes.
 * Returns one of: 'self' | 'strong_ally' | 'semi_ally' | 'enemy'
 */
export const getRelationship = (playerCode, otherCode) => {
  if (playerCode === otherCode) return 'self';
  const map = ALLIANCE_MAP[playerCode];
  if (!map) return 'enemy';
  if (map.strongAlly === otherCode) return 'strong_ally';
  if (map.semiAlly === otherCode) return 'semi_ally';
  return 'enemy';
};

/**
 * Onboarding window: arrows only show while this returns true.
 * Turns 1-2 of the player's career in this game.
 */
export const ONBOARDING_LAST_TURN = 2;

/**
 * Visual config per relationship kind.
 */
export const ARROW_CONFIG = {
  self: {
    label: 'YOUR NATION',
    icon: '🎯',
    color: '#22d3ee',          // cyan
    glow: 'rgba(34, 211, 238, 0.6)',
  },
  strong_ally: {
    label: 'STRENGTHEN BOND',
    icon: '🤝',
    color: '#fbbf24',          // amber-gold
    glow: 'rgba(251, 191, 36, 0.6)',
  },
  semi_ally: {
    label: 'USE DIPLOMACY',
    icon: '🤝',
    color: '#facc15',          // yellow (dimmer than gold)
    glow: 'rgba(250, 204, 21, 0.4)',
  },
  enemy: {
    label: 'TAP TO TARGET',
    icon: '☢️',
    color: '#ef4444',          // red
    glow: 'rgba(239, 68, 68, 0.7)',
  },
};
